import { EitherAsync } from 'purify-ts/EitherAsync';
import * as api from '@codegrade/api';
import { eitherAsync } from '@codegrade/utils';
import { getErrorMessage } from './error';
import { ifExpr } from './expr';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function emptyResponse() {
    return eitherAsync.rightFromValue(api.ApiResult.fromResponseAndValue(new Response(), null));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function responseWithValue(value) {
    return eitherAsync.rightFromValue(api.ApiResult.fromResponseAndValue(new Response(), value));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function errorResponse(message) {
    return eitherAsync.leftFromValue(new Error(message));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function loadWithMaybeForce(value, loader, force, load, makeDefault) {
    const loadIfForce = ifExpr(force, 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    () => () => load(), () => 
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (dflt) => dflt());
    return value.caseOf({
        Just: justValue => loader.caseOf({
            Just: dflt => loadIfForce(() => dflt),
            Nothing: () => loadIfForce(() => makeDefault(justValue)),
        }),
        Nothing: () => loader.caseOf({
            Just: val => val,
            Nothing: load,
        }),
    });
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function loadApiWithMaybeForce(data) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const addAndLoad = () => {
        const loader = eitherAsync.eager(eitherAsync.cached(data.load().finally(() => data.removeLoader())));
        data.addLoader(loader);
        return loader;
    };
    return loadWithMaybeForce(data.value, data.loader, data.force, () => EitherAsync(({ fromPromise }) => fromPromise(addAndLoad())), value => responseWithValue(value));
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function isApiError(err) {
    return err instanceof api.ApiResultError && err.error instanceof api.BaseError;
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function loadBackgroundApis(...eitherAsyncs) {
    for (const val of eitherAsyncs) {
        val.ifLeft(err => {
            // eslint-disable-next-line
            console.error(new Error(getErrorMessage(err)), err);
        }).run();
    }
}
